<script lang="ts">
import { defineComponent } from 'vue'
import PageTitle from '@/components/PageTitle.vue'

interface Props {
  title: string
  subTitle: string | null
  logoSrc: string | null
  logoAlt: string | null
}

export default defineComponent<Props>({
  name: 'DefaultLayout',

  components: {
    PageTitle,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
      default: null,
    },
    logoSrc: {
      type: String,
      required: false,
      default: null,
    },
    logoAlt: {
      type: String,
      required: false,
      default: null,
    },
  },

})

</script>

<template>
  <article class="page">
    <page-title
      :title="title"
      :sub-title="subTitle"
      :logo-src="logoSrc"
      :logo-alt="logoAlt"
    />
    <main>
      <div class="container">
        <slot />
      </div>
    </main>
  </article>
</template>

<style lang="scss" scoped>
.page {
  @apply min-h-screen flex px-0 py-11 flex-wrap;

  ::v-deep > header {
    @apply mt-auto w-full;
  }

  > main {
    @apply mb-auto w-full;
  }
}
</style>
